module.exports = __webpack_public_path__ + "img/dept-4.c27293de.svg";